import { VoucherListPage } from '@/features/voucher/pages/VoucherListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/voucher/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["voucher.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: VoucherListPage,
})
